export function popUp({ path, onClose, onMessage, windowName, windowOptions }) {
  windowName = windowName || "DriftSegmentInstaller" // should not include space for IE
  windowOptions = windowOptions || "location=0,status=0,width=800,height=650"
  onClose = onClose || function() {}
  const _oauthWindow = window.open(path, windowName, windowOptions)
  const _oauthInterval = window.setInterval(function() {
    if (_oauthWindow.closed) {
      window.clearInterval(_oauthInterval)
      onClose()
    }
  }, 1000)
  const eventer = window.addEventListener

  eventer("message", e => {
    if (e.origin !== window.location.origin || e.source !== _oauthWindow)
      return
    !!onMessage && onMessage(e)
  })

  return _oauthWindow
}



// WEBPACK FOOTER //
// ./src/layouts/OnboardingInstallStep/SegmentInstall/helpers.js